export default {
    makeArrayIntoHash: (array, idColumn) => {
        let hash = {};
        for (var index in array) {
            let value = array[index];
            hash[value[idColumn]] = value;
        }
        return hash;
    },
    filterObject: (object, filterFunction) => {
        let newObject = {};
        for (var index in object) {
            let value = object[index];
            if (filterFunction(value, index)) {
                newObject[index] = value;
            }
        }
        return newObject;
    },
    getValueById: (values, id) => {
        for (let i = 0; i < values.length; i++) {
            if (values[i].id.toString() === id.toString()) return values[i];
        }
        return values[0];
    },
    convertWindowSize: (value, currentUnit, wantedUnit) => {
        const CONVERSION_COEFF = 25.4;
        if (currentUnit === "mm" && wantedUnit === "inch") return value / CONVERSION_COEFF;
        if (currentUnit === "mm" && wantedUnit === "m") return value / 1000;
        if (currentUnit === "mm" && wantedUnit === "ft") return value / 304.8;

        if (currentUnit === "inch" && wantedUnit === "mm") return value * CONVERSION_COEFF;
        if (currentUnit === "inch" && wantedUnit === "m") return (value * CONVERSION_COEFF) / 1000;
        if (currentUnit === "inch" && wantedUnit === "ft") return value * 12;

        if (currentUnit === "m" && wantedUnit === "mm") return value * 1000;
        if (currentUnit === "m" && wantedUnit === "inch") return (value * 1000) / CONVERSION_COEFF;
        if (currentUnit === "m" && wantedUnit === "ft") return value / 0.3048;

        if (currentUnit === "ft" && wantedUnit === "mm") return value * 304.8;
        if (currentUnit === "ft" && wantedUnit === "inch") return value / 12;
        if (currentUnit === "ft" && wantedUnit === "m") return value * 0.3048;

        return value;
    },
    getExtraBestMatch: (extras, selectedColour, useAltBestMatch = false) => {

        let bestGuessMatch = selectedColour.bestGuessMatch;

        if (useAltBestMatch) {
            bestGuessMatch = selectedColour.altBestGuessMatch;
        }

        let extraIndex = 0;
        if (bestGuessMatch) {
            extraIndex = extras.findIndex(h => h.name.indexOf(bestGuessMatch) !== -1);
        }
        var extraId = extras[extraIndex] ? extras[extraIndex].id : extras[0].id;
        return extraId;
    },
    sortExtraByRank: (extraA, extraB) => {
        if (extraA.rank1 !== extraB.rank1)
            return extraA.rank1 - extraB.rank1;
        if (extraA.rank2 !== extraB.rank2)
            return extraA.rank2 - extraB.rank2;
        if (extraA.rank3 !== extraB.rank3)
            return extraA.rank3 - extraB.rank3;
        return 0;
    },
    findHardwareByColour: (hardwares, hardwardColour) => {

        if (hardwardColour === null)
            return null;

        var hardwareByColour = hardwares.filter((hardware) => hardware.description1 === hardwardColour);

        if (hardwareByColour.length === 1)
            return hardwareByColour[0].id;

        return null;
    },
    findHandleByColour: (handles, handleColour, handleType) => {

        if (handleColour === null || handleType === null)
            return null;

        var handleByColour = handles.filter((handle) => handle.description1 === handleColour);

        // if there's no handle of that colour, return null
        if (handleByColour.length === 0)
            return null;

        var handleByType = handleByColour.filter(handle => handle.description2 === handleType);

        // if there's no handle of that colour and type
        // check if we have a single one that match by colour, otherwise return null
        if (handleByType.length === 0) {
            if (handleByColour.length === 1)
                return handleByColour[0].id;
            return null;
        }

        // if there's a handle that matches colour and type, return its id
        if (handleByType.length === 1)
            return handleByType[0].id;

        return null;
    },
    formatNumber: number => {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    checkProductSuiteExists: (nameKey, myArray) => {
        for (var i=0; i < myArray.length; i++) {
            if (myArray[i].name === nameKey) {
                return true;
            }
        }
        return false;
    },
    percentFormatter: (value, unit) => {
        if(unit === "m"){
            return `${value}`
        }
        const inchPart = (value%1);
        const feetPart = value - inchPart;
        return `${feetPart}ft${inchPart !== 0 ? ` ${Math.round(inchPart*12)}in`:``}`;
    }
};



// WEBPACK FOOTER //
// ./src/utils/index.js